const state = {
  loadedAsyncLinks: [],
  guideAppAlertFlag: false,
  guideBrowserOpenFlag: false,
  token: '',
  user: null,
  audioEle: null,
  isIosInitWxSDK: false,
  currentDateObj: null,
  qiYu: {
    isStart: false, // 是否已经启动了七鱼客服
    unreadNum: 0 //  未读消息数量
  },
  isUpdateCard: {
    id: '', // 打卡ID
    isWho: 0, // 1 更新点赞列表  2 更新评论列表  3 更新班委点评数据
    stars: -1, // 更新点赞列表, 1添加用户的点赞信息，0 移除
    adminComment: { // 班委点评更新
      level: 0,
      content: null,
      isTop: false
    }
  },
  themeUrl: '', // 保存打卡主题页的URL
  studyPageHeadHeight: 0, // 学习页的头部组件高度
};

export default state;
